import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'

import * as reducers from './reducers'

const middleware = [thunk]

export default createStore(
  combineReducers(reducers),
  compose(applyMiddleware(...middleware))
)
